export default class Utils {
    //decimals must be an integer number
    static roundNumber(val: number,decimals:number){
        let result = NaN;
        let sign = 1;
        if(val < 0){
            sign = -1;
        }
        result = ((Math.round(Math.abs(val)*Math.pow(10,decimals)))/Math.pow(10,decimals))*sign;
        return result;
    }

    //decimals must be an integer number
    static toFixedNumber(value:number,decimals:number): number{
        let result = 0;
        result = Number(value.toFixed(decimals));
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/util/Util.ts